import { ErrorActions } from "../reducers/error";

export const { setError } = ErrorActions;
